import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { adminClient } from '@/lib/adminClient';

export const suspensionKeys = {
  all: ['suspension'] as const,
  detail: (userId: string) => [...suspensionKeys.all, userId] as const,
};

export function useSuspension(userId: string) {
  return useQuery({
    queryKey: suspensionKeys.detail(userId),
    queryFn: () => adminClient.getSuspension(userId),
    enabled: Boolean(userId),
  });
}

// Suspends a user until a timestamp, or permanently (a ban). The server
// records the acting admin from the IAP identity — the client never sends it.
export function useUpdateSuspension(userId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: { suspendedUntil?: string; permanent?: boolean; reason: string }) =>
      adminClient.updateSuspension({ userId, ...params }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: suspensionKeys.detail(userId) });
    },
  });
}

export function useDeleteSuspension(userId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: { reason: string }) =>
      adminClient.deleteSuspension({ userId, ...params }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: suspensionKeys.detail(userId) });
    },
  });
}
